import type {TicketStatus, TicketPriority} from '../types/ticket';

export interface FilterOption<T extends string = string> {
	id: T;
	label: string;
}

export const STATUS_OPTIONS: FilterOption<TicketStatus>[] = [
	{id: 'open', label: 'Open'},
	{id: 'in_progress', label: 'In progress'},
	{id: 'waiting_on_customer', label: 'Waiting on customer'},
	{id: 'resolved', label: 'Resolved'},
	{id: 'closed', label: 'Closed'},
];

export const PRIORITY_OPTIONS: FilterOption<TicketPriority>[] = [
	{id: 'p0', label: 'Critical'},
	{id: 'p1', label: 'High'},
	{id: 'p2', label: 'Medium'},
	{id: 'p3', label: 'Low'},
];

export const SLA_OPTIONS: FilterOption<string>[] = [
	{id: 'breached', label: 'Breached'},
	{id: 'paused', label: 'Paused'},
];

export const UNASSIGNED_OPTION: FilterOption = {
	id: '__unassigned__',
	label: 'Unassigned',
};
